import React from "react";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import { Badge, IconButton, Tooltip } from "@mui/material";

interface ViewImagesButtonProps {
  total: number;
  unseen: number;
  onClick: () => void;
  disabled?: boolean;
}

const ViewImagesButton: React.FC<ViewImagesButtonProps> = ({
  total,
  unseen,
  onClick,
  disabled = false,
}) => {

  return (
    <Tooltip title="View Images">
      <Badge badgeContent={unseen} color="error" overlap="circular">
        <IconButton
          onClick={onClick}
          disabled={disabled || total === 0}
        >
          <PhotoLibraryIcon />
        </IconButton>
      </Badge>
    </Tooltip>
  );
};

export default ViewImagesButton;
